<template>
  <el-dialog
    :modal="true"
    :modal-append-to-body="true"
    :title="title"
    :visible.sync="show"
    :close-on-click-modal="false"
    :show-close="true"
    :close-on-press-escape="true"
    :before-close="clickCancel"
    width="600px" class="add_post_dialog">
    <el-form :model="newPostForm" :rules="rules" ref="newPostForm" class="newPostForm">
      <el-form-item prop="postName" label="岗位名称">
        <el-input v-model.trim="newPostForm.postName" autocomplete="off" placeholder="请输入岗位名称" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item prop="postCode" label="岗位编码">
        <el-input v-model.trim="newPostForm.postCode" autocomplete="off" placeholder="请输入岗位编码" maxlength="20"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="clickCancel">取消</el-button>
      <el-button type="primary" @click="submitForm('newPostForm')">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    },
    newPostForm: {
      type: Object,
      default: function(){
        return {
          postName:'',
          postCode:''
        }
      }
    },
    showModalconfirm:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      show:false,
      rules: {
        postName: [
          { required: true, message: '请输入岗位名称', trigger: 'blur' },
          // { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        postCode:[
          { required: true, message: '请输入岗位编码', trigger: 'blur' }
        ],
      }
    }
  },
  created() {
  },
  methods: {
    clickCancel(){
      this.show = false
      this.$emit('cancelAddPost')
      this.resetForm('newPostForm')
    },
    submitForm(formName){
      this.$refs[formName].validate((valid, formdata) => {
        if (valid) {
          this.$emit('confirmAddPost',this.newPostForm);
          this.resetForm(formName)
        }else{
          console.log('error')
          return false
        }
      })
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  watch:{
    showModalconfirm(val){
      this.show = val
    }
  }
}
</script>
<style lang="scss">
  .add_post_dialog{
    .newPostForm{
      width: 340px;
      margin: 30px auto 0;
    }
    .el-form-item{
      .el-form-item__label{
        font-size:14px;
        font-weight:400;
        line-height: 34px;
        color:rgba(51,51,51,1);
      }
      .el-form-item__content{
        .el-input{
          width: 260px;
          .el-input__inner{
            height: 34px;
            line-height: 34px;
          }
        }
        .el-form-item__error{
          margin-left: 80px;
        }
      }
    }
    .el-dialog__footer{
      padding-bottom: 48px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/educationalAdmin/educationalAdminMenu/subjectDialog/addPostDialog.vue